// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recordings-right-data {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.recordings-right-data .custom-tool-tip {
  margin-right: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/ViewWork/RecordingsSection/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;AACJ","sourcesContent":[".recordings-right-data {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  .custom-tool-tip {\n    margin-right: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
